import { cssGenerator } from '@yola/ws-sdk';
import getResolvedState from './get-resolved-state';

const { AUTO_FILL_PREFIX } = cssGenerator.constants;

const getBreakpointValuesWithAuto = (values = {}, autoValues = {}) =>
  Object.fromEntries(
    [...new Set([...Object.keys(values), ...Object.keys(autoValues)])]
      .map((breakpointKey) => [
        breakpointKey,
        values[breakpointKey] !== undefined ? values[breakpointKey] : autoValues[breakpointKey],
      ])
      .filter(([, value]) => value !== undefined)
  );

const getStateWithAuto = (state) =>
  Object.fromEntries(
    Object.entries(state).map(([elementId, elementState]) => {
      const nextTargets = { ...elementState };

      Object.keys(elementState).forEach((autoTarget) => {
        if (!autoTarget.startsWith(AUTO_FILL_PREFIX)) {
          return;
        }

        const target = autoTarget.slice(AUTO_FILL_PREFIX.length);
        const values = getBreakpointValuesWithAuto(elementState[target], elementState[autoTarget]);

        if (Object.keys(values).length) {
          nextTargets[target] = values;
        }
      });

      return [elementId, nextTargets];
    })
  );

const getResolvedStateWithAutoFill = (state, activeBreakpointKey) =>
  getResolvedState(getStateWithAuto(state), activeBreakpointKey);

export default getResolvedStateWithAutoFill;
